import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-dislike-icon',
  templateUrl: './general-dislike.component.html'
})
export class GeneralDislikeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
